<!-- 封装音频播放器 -->
<template>
    <div class="play-container" @mouseenter="onEnterTd" @mouseleave="onLeaveTd">
      <svg viewBox="0 0 100 100" :class="isSvg?'svg':'svg-none'">
         <path d="M 0,50 a 50,50 0 1,1 0,1 z" id="circle" />
             <text>
                 <textPath xlink:href="#circle">{{textList[id]}}</textPath>
             </text>
      </svg>
      <el-image class="bg-img" :src="gifImg" v-if="isPlay"></el-image>
      <el-image class="bg-img" :src="bgList[id]" v-else></el-image>
      <div class="play" @click="pause">
          <i class="el-icon-video-play" style="font-size:60px" v-show="!isPlay"></i>
          <!-- <i class="el-icon-video-pause" style="font-size:60px" v-show="isPlay"></i> -->
      </div>
    </div>
  </template>
  <script>
  import play1 from "@/assets/play1.png"
  import play2 from "@/assets/play2.png"
  import play3 from "@/assets/play3.png"
  import play4 from "@/assets/play4.png"
  import play5 from "@/assets/play5.png"
  import play6 from "@/assets/play6.png"
  import song1 from "@/assets/song1.mp3"
  import song2 from "@/assets/song2.mp3"
  import song3 from "@/assets/song3.mp3"
  import song4 from "@/assets/song4.mp3"
  import song5 from "@/assets/song5.mp3"
  import song6 from "@/assets/song6.mp3"
  import gif1 from "@/assets/gif1.gif"
  import gif2 from "@/assets/gif2.gif"
  import gif3 from "@/assets/gif3.gif"
  import gif4 from "@/assets/gif4.gif"
  import gif5 from "@/assets/gif5.gif"
  import gif6 from "@/assets/gif6.gif"
  export default {
      props: {
        id: {
            type: Number,
            default: null
        },
      },
    data () {
      return {
          bgList:[play1,play2,play3,play4,play5,play6],
          isPlay:false,
          mp3List:[song1,song2,song3,song4,song5,song6],
          gifList:[gif1,gif2,gif3,gif4,gif5,gif6],
          textList:["SERENDIPITY","INCALESCENCE","JEOPARDY","PEST","HUMID","GHOST"],
          canplay:false,
          audio: "",
          isSvg:false,
          gifImg:''
      };
    },
    created(){
      this.audio = document.createElement("audio");
      this.audio.src = this.mp3List[this.id]
      let that = this
      this.audio.addEventListener(
        "canplay",
        function () {
          that.canplay = true;
        },
        false
      ),
      this.audio.addEventListener(
            "ended",
            function () {
              that.audio.pause(); // 暂停
              that.isPlay = false;
            },
            false
      ) 
  },
  methods: {
      pause() {
          if (this.audio !== null && this.canplay) {
            this.loading = true;
            if (this.audio.paused) {
              this.audio.play(); // 播放
              this.gifImg = this.gifList[this.id]+'?+'+new Date()
              this.isPlay = true;
            } else {
              // this.audio.pause(); // 暂停
              // this.isPlay = false;
            }
          } else {
              this.$message({
              showClose: true,
              message: "音乐还没有加载成功呢！",
              type: "warning",
            });
          }
      },
      //鼠标进入的事件。
      onEnterTd(e) {
        this.isSvg = true
      },
      //鼠标离开的事件。
      onLeaveTd(e) {
        this.isSvg = false
      },
    }
  }
  </script>
  <style lang='less' scoped>
  .play-container{
      position: relative;
      width: 150px;
      height: 150px;
      .bg-img{
        position: absolute;
        left:0;
        top: 0;
        width: 150px;
        height: 150px;
        border-radius: 50%;
      }
     .play{
        position: absolute;
        left: 31%;
        top: 31%;
      }
  }
.play-container path { fill: none; }
.play-container .svg { 
  display: block; 
  overflow: visible; 
  animation: myfirst 6s infinite linear;
}
.play-container .svg-none {
  display: none; 
  overflow: visible;
}
@keyframes myfirst
{
	from {transform:rotate(0deg);}
	to {transform:rotate(360deg);}
}
@-webkit-keyframes myfirst
{
	from {transform:rotate(0deg);}
	to {transform:rotate(360deg);}
}
  </style>